import type { ReactNode } from 'react'
import { View } from 'react-native'

import { dividerVariants } from './divider-variants'

export type TDividerProps = {
  orientation: 'horizontal' | 'vertical'
}

export const Divider = (props: TDividerProps): ReactNode => {
  const { orientation } = props
  return <View className={dividerVariants({ orientation })} />
}
